/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useContext } from "react";

import { noop } from "lodash";
import { LANGUAGES } from "@/shared";

import ListChoice from "../../../components/ListChoice/ListChoice";
import LanguageContext from "../../../context/language/LanguageContext";

interface LanguageListProps {
  externalOnClick?: (id: LANGUAGES) => void;
}

const LanguageList = ({ externalOnClick }: LanguageListProps) => {
  const { languages, language, setNewLanguage } = useContext(LanguageContext);

  const handleClick = (id: LANGUAGES, isSelected: boolean) => {
    if (isSelected) {
      return noop();
    }

    if (externalOnClick) {
      return externalOnClick(id);
    }

    return setNewLanguage(id);
  };

  return (
    <>
      {languages.map(({ id, text }) => {
        const isSelected = id === language;

        return (
          <ListChoice
            key={id}
            title={text}
            selected={isSelected}
            css={css({ pointerEvents: isSelected ? "none" : "auto" })}
            onClick={() => handleClick(id, isSelected)}
          />
        );
      })}
    </>
  );
};

export default LanguageList;
